export const colors = {
  primary: {
    50: '#fef7ee',
    100: '#fdedd3',
    200: '#fbd9a5',
    300: '#f8c06d',
    400: '#f59e0b',
    500: '#ea580c',
    600: '#dc2626',
    700: '#b91c1c',
    800: '#991b1b',
    900: '#7c2d12',
  },
  coffee: {
    light: '#d4a574',
    medium: '#8b4513',
    dark: '#3e2723',
    cream: '#f5f5dc',
    espresso: '#2d1b14',
  },
  semantic: {
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444',
    info: '#3b82f6',
  },
  neutral: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#e5e5e5',
    300: '#d4d4d4',
    400: '#a3a3a3',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
  },
  background: {
    primary: '#ffffff',
    secondary: '#f8fafc',
    tertiary: '#f1f5f9',
  },
  text: {
    primary: '#1f2937',
    secondary: '#6b7280',
    tertiary: '#9ca3af',
    inverse: '#ffffff',
  },
  border: {
    light: '#e5e7eb',
    medium: '#d1d5db',
    dark: '#9ca3af',
  },
} as const;

export const darkColors = {
  ...colors,
  background: {
    primary: '#111827',
    secondary: '#1f2937',
    tertiary: '#374151',
  },
  text: {
    primary: '#f9fafb',
    secondary: '#d1d5db',
    tertiary: '#9ca3af',
    inverse: '#111827',
  },
  border: {
    light: '#374151',
    medium: '#4b5563',
    dark: '#6b7280',
  },
} as const;

export type ColorScheme = typeof colors;
export type ColorKey = keyof ColorScheme;
